// User Roles
export const USER_ROLES = {
    SUPER_ADMIN: 'super_admin',
    ORG_ADMIN: 'org_admin',
    ORG_MODERATOR: 'org_moderator',
    ORG_INSTRUCTOR: 'org_instructor',
    ORG_MEMBER: 'org_member',
    INDIVIDUAL_USER: 'individual_user',
} as const;

// Exam Types
export const EXAM_TYPES = {
    PRACTICE: 'practice',
    ASSESSMENT: 'assessment',
    CERTIFICATION: 'certification',
    SURVEY: 'survey',
    LIVE_QUIZ: 'live_quiz',
} as const;

// Exam Status
export const EXAM_STATUS = {
    DRAFT: 'draft',
    SCHEDULED: 'scheduled',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ARCHIVED: 'archived',
} as const;

// Attempt Status
export const ATTEMPT_STATUS = {
    IN_PROGRESS: 'in_progress',
    SUBMITTED: 'submitted',
    AUTO_SUBMITTED: 'auto_submitted',
    ABANDONED: 'abandoned',
} as const;

// Question Types
export const QUESTION_TYPES = {
    MCSA: 'mcq_single',
    MCMA: 'mcq_multiple',
    TRUE_FALSE: 'true_false',
    FILL_BLANKS: 'fill_blank',
    SHORT_ANSWER: 'short_answer',
    LONG_ANSWER: 'long_answer',
    CODE: 'code',
} as const;

// Question Status (for palette)
export const QUESTION_PALETTE_STATUS = {
    NOT_VISITED: 'not_visited',
    NOT_ANSWERED: 'not_answered',
    ANSWERED: 'answered',
    MARKED: 'marked',
    MARKED_ANSWERED: 'marked_answered',
} as const;

// Time Warnings (in seconds)
export const TIME_WARNINGS = [300, 120, 60, 30]; // 5min, 2min, 1min, 30sec

// Auto-save interval (in seconds)
export const AUTO_SAVE_INTERVAL = 30;

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// Local Storage Keys
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'testam_auth_token',
    USER_DATA: 'testam_user_data',
    THEME: 'testam_theme',
    LAST_ROUTE: 'testam_last_route',
} as const;

// Routes
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    DASHBOARD: '/dashboard',
    EXAMS: '/exams',
    EXAM_DETAIL: '/exams/:id',
    EXAM_CREATE: '/exams/create',
    EXAM_EDIT: '/exams/:id/edit',
    TAKE_EXAM: '/take-exam/:id',
    RESULTS: '/results/:attemptId',
    PROFILE: '/profile',
    SETTINGS: '/settings',
} as const;
